import { LoadingStatusType } from "@/enums/enums";
import { AllocationItemModel } from "@/model/allocation/allocationModel";
import API from "@/service/Index";
import { ConvertToAllocationItemModel } from "@/service/allocation/allocationFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Allocation extends VuexModule {
  private allocationListLoadingStatus = LoadingStatusType.None;
  private allocationItemList: AllocationItemModel[] = [];

  get getAllocationItemList() {
    return this.allocationItemList;
  }

  get getAllocationListLoadingStatus() {
    return this.allocationListLoadingStatus;
  }

  @Mutation
  public MutationAllocationListLoadingStatus(status: LoadingStatusType) {
    this.allocationListLoadingStatus = status;
  }

  @Mutation
  public MutationAllocationItemList(allocationList: AllocationItemModel[]) {
    this.allocationItemList = allocationList;
  }

  @Action
  DoGetAllocationList() {
    if (this.allocationListLoadingStatus != LoadingStatusType.Loading) {
      this.context.commit("MutationAllocationListLoadingStatus", LoadingStatusType.Loading);
      const input = {
        isUseMainDatabase: true,
      };
      API.AllocationService.DoGetAllocationList(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const allocationList = ConvertToAllocationItemModel(res.data.allocationList);
          this.context.commit("MutationAllocationItemList", allocationList);
          this.context.commit("MutationAllocationListLoadingStatus", LoadingStatusType.Success);
        } else {
          this.context.commit("MutationAllocationListLoadingStatus", LoadingStatusType.Fail);
        }
      });
    }
  }
}
